export default [
  {
    value: 'px',
    title: 'px'
  },
  {
    value: 'in',
    title: 'in'
  },
  {
    value: 'pt',
    title: 'pt'
  },
  {
    value: 'em',
    title: 'em'
  },
  {
    value: '%',
    title: '%'
  }
]
